export function nextAvailableRelease(value: string, existing: readonly string[]): string {
  const match = value.match(/^(.*?)(\d+)$/);
  if (!match) {
    const used = new Set(existing);
    let candidate = `${value}-next`;
    let suffix = 2;
    while (used.has(candidate)) candidate = `${value}-next-${suffix++}`;
    return candidate;
  }
  const prefix = match[1]!;
  const highest = existing.reduce((maximum, releaseVersion) => {
    const candidate = releaseVersion.match(/^(.*?)(\d+)$/);
    return candidate?.[1] === prefix ? Math.max(maximum, Number(candidate[2])) : maximum;
  }, Number(match[2]));
  return `${prefix}${highest + 1}`;
}

export function nextReleaseForKey(value: string, releaseKey: string, existing: readonly string[]): string {
  const root = value.replace(/-v\d+$/, '');
  const key = releaseKey.toLowerCase().replace(/[^a-z0-9._-]+/g, '-').replace(/^-+|-+$/g, '');
  const reservedSuffixLength = 4;
  const prefix = `${root}-${key}`.slice(0, 64 - reservedSuffixLength).replace(/-+$/, '');
  return nextAvailableRelease(`${prefix}-v0`, existing);
}
